import React from 'react';
import { Typography, TypographyProps } from '@mui/material';

const H5 = ({ children, ...props }: TypographyProps) => {
  return (
    <Typography {...props} variant="h5">{children}</Typography>
  );
};

export default H5;